import Notification from '../../../components/Notification';
import { FormattedMessage } from 'react-intl';

const { id: module_id } = module;

export default function ({ setVisibility }) {
  return (
    <Notification className={'primary-green center'}>
      <div className="floating-close" onClick={() => setVisibility(false)}>
        &#x2715;
      </div>
      <p>
        <FormattedMessage id={`${module_id}.message`} />
      </p>
    </Notification>
  );
}
